module.exports = __webpack_public_path__ + "static/media/iconfinder_ic_account_circle_48px_352002.12cadb51.svg";